/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/search-panel/components/fulltext-search-panel.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../src/app/search-panel/services/date.service';
import * as import6 from '../../../../../src/app/search-panel/services/search-config.service';
import * as import7 from '../../../../../src/app/search-panel/services/search-api.service';
import * as import8 from '../../../../../src/app/search-panel/services/search-model-util.service';
import * as import9 from '@angular/core/src/linker/view_type';
import * as import10 from '@angular/core/src/change_detection/constants';
import * as import11 from '@angular/core/src/linker/component_factory';
import * as import12 from '../../../../../src/app/shared/services/config.service';
import * as import13 from '../../../../../src/app/shared/services/query-string.service';
import * as import14 from '../../../../../src/app/shared/services/api.service';
import * as import15 from '../../../../../src/app/shared/services/messenger.service';
import * as import16 from '../../../../../src/app/search-panel/components/doctype-selector.component';
import * as import17 from './doctype-selector.component.ngfactory';
import * as import18 from '@angular/core/src/linker/view_container';
import * as import19 from '../../../../../src/app/search-panel/components/search-form.component';
import * as import20 from '../../../../../src/app/search-panel/services/search-form.service';
import * as import21 from '../../../../../src/app/search-panel/services/search-form-util.service';
import * as import22 from './search-form.component.ngfactory';
import * as import23 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import24 from '../../../../../src/app/shared/components/status.component';
import * as import25 from '../../shared/components/status.component.ngfactory';
import * as import26 from 'ng2-translate/src/translate.pipe';
import * as import27 from '@angular/core/src/linker/template_ref';
import * as import28 from 'ng2-translate/src/translate.service';
import * as import29 from '@angular/common/src/directives/ng_if';
import * as import30 from '@angular/core/src/change_detection/change_detection_util';
export class Wrapper_FulltextSearchPanelComponent {
  /*private*/ _eventHandler:Function;
  context:import0.FulltextSearchPanelComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any) {
    this._changed = false;
    this.context = new import0.FulltextSearchPanelComponent(p0,p1,p2,p3);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_FulltextSearchPanelComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_FulltextSearchPanelComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.FulltextSearchPanelComponent>;
  _DateService_0_3:import5.DateService;
  _SearchConfigService_0_4:import6.SearchConfigService;
  _SearchApiService_0_5:import7.SearchApiService;
  _SearchModelUtilService_0_6:import8.SearchModelUtilService;
  _FulltextSearchPanelComponent_0_7:Wrapper_FulltextSearchPanelComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_FulltextSearchPanelComponent_Host0,renderType_FulltextSearchPanelComponent_Host,import9.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-fulltext-search-panel',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_FulltextSearchPanelComponent0(this.viewUtils,this,0,this._el_0);
    this._DateService_0_3 = new import5.DateService();
    this._SearchConfigService_0_4 = new import6.SearchConfigService(this.injectorGet(import12.ConfigService,this.parentIndex),this.injectorGet(import13.QueryStringService,this.parentIndex),this._DateService_0_3);
    this._SearchApiService_0_5 = new import7.SearchApiService(this.injectorGet(import14.ApiService,this.parentIndex),this._SearchConfigService_0_4);
    this._SearchModelUtilService_0_6 = new import8.SearchModelUtilService(this._SearchConfigService_0_4);
    this._FulltextSearchPanelComponent_0_7 = new Wrapper_FulltextSearchPanelComponent(this._SearchApiService_0_5,this._SearchConfigService_0_4,this.injectorGet(import15.MessengerService,this.parentIndex),this._SearchModelUtilService_0_6);
    this.compView_0.create(this._FulltextSearchPanelComponent_0_7.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import11.ComponentRef_<any>(0,this,this._el_0,this._FulltextSearchPanelComponent_0_7.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.DateService) && (0 === requestNodeIndex))) { return this._DateService_0_3; }
    if (((token === import6.SearchConfigService) && (0 === requestNodeIndex))) { return this._SearchConfigService_0_4; }
    if (((token === import7.SearchApiService) && (0 === requestNodeIndex))) { return this._SearchApiService_0_5; }
    if (((token === import8.SearchModelUtilService) && (0 === requestNodeIndex))) { return this._SearchModelUtilService_0_6; }
    if (((token === import0.FulltextSearchPanelComponent) && (0 === requestNodeIndex))) { return this._FulltextSearchPanelComponent_0_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._FulltextSearchPanelComponent_0_7.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const FulltextSearchPanelComponentNgFactory:import11.ComponentFactory<import0.FulltextSearchPanelComponent> = new import11.ComponentFactory<import0.FulltextSearchPanelComponent>('obpa-fulltext-search-panel',View_FulltextSearchPanelComponent_Host0,import0.FulltextSearchPanelComponent);
const styles_FulltextSearchPanelComponent:any[] = ([] as any[]);
class View_FulltextSearchPanelComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import16.DocTypeSelectorComponent>;
  _DocTypeSelectorComponent_2_3:import17.Wrapper_DocTypeSelectorComponent;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_FulltextSearchPanelComponent2,renderType_FulltextSearchPanelComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','well well-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'obpa-doctype-selector',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import17.View_DocTypeSelectorComponent0(this.viewUtils,this,2,this._el_2);
    this._DocTypeSelectorComponent_2_3 = new import17.Wrapper_DocTypeSelectorComponent(this.parentView.parentView.injectorGet(import7.SearchApiService,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import6.SearchConfigService,this.parentView.parentIndex));
    this._text_3 = this.renderer.createText((null as any),'\n        ',(null as any));
    this.compView_2.create(this._DocTypeSelectorComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'selectionChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._DocTypeSelectorComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import16.DocTypeSelectorComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._DocTypeSelectorComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.parentView.context.selectedDoctype;
    this._DocTypeSelectorComponent_2_3.check_selection(currVal_2_0_0,throwOnChange,false);
    this._DocTypeSelectorComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._DocTypeSelectorComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'selectionChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.selectedDoctype = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'selectionChange')) {
      const pd_sub_1:any = ((<any>this.parentView.parentView.context.onSelectedDoctypeChange($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_FulltextSearchPanelComponent3 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import19.SearchFormComponent>;
  _SearchFormService_0_3:import20.SearchFormService;
  _SearchFormUtilService_0_4:import21.SearchFormUtilService;
  _SearchFormComponent_0_5:import22.Wrapper_SearchFormComponent;
  _text_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_FulltextSearchPanelComponent3,renderType_FulltextSearchPanelComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'obpa-search-form',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import22.View_SearchFormComponent0(this.viewUtils,this,0,this._el_0);
    this._SearchFormService_0_3 = new import20.SearchFormService();
    this._SearchFormUtilService_0_4 = new import21.SearchFormUtilService(this.parentView.parentView.injectorGet(import5.DateService,this.parentView.parentIndex));
    this._SearchFormComponent_0_5 = new import22.Wrapper_SearchFormComponent(this.compView_0.ref,this._SearchFormService_0_3,this._SearchFormUtilService_0_4);
    this._text_1 = this.renderer.createText((null as any),'\n        ',(null as any));
    this.compView_0.create(this._SearchFormComponent_0_5.context);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'search',(null as any)),this.eventHandler(this.handleEvent_0));
    this._SearchFormComponent_0_5.subscribe(this,this.eventHandler(this.handleEvent_0),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.SearchFormService) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._SearchFormService_0_3; }
    if (((token === import21.SearchFormUtilService) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._SearchFormUtilService_0_4; }
    if (((token === import19.SearchFormComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._SearchFormComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parentView.parentView.context.searchFormModel;
    this._SearchFormComponent_0_5.check_searchFormModel(currVal_0_0_0,throwOnChange,false);
    if (this._SearchFormComponent_0_5.ngDoCheck(this,this._el_0,throwOnChange)) { this.compView_0.markAsCheckOnce(); }
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._SearchFormComponent_0_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'search')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.performManualSearch($event.value)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_FulltextSearchPanelComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import18.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import23.Wrapper_NgIf;
  _text_3:any;
  _el_4:any;
  compView_4:import1.AppView<import24.StatusComponent>;
  _StatusComponent_4_3:import25.Wrapper_StatusComponent;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _vc_6:import18.ViewContainer;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import23.Wrapper_NgIf;
  _text_7:any;
  _text_8:any;
  _pipe_translate_0:import26.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_FulltextSearchPanelComponent1,renderType_FulltextSearchPanelComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import18.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import27.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import23.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n    \n    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'obpa-status',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import25.View_StatusComponent0(this.viewUtils,this,4,this._el_4);
    this._StatusComponent_4_3 = new import25.Wrapper_StatusComponent();
    this._text_5 = this.renderer.createText((null as any),'\n    \n        ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor((null as any),(null as any));
    this._vc_6 = new import18.ViewContainer(6,4,this,this._anchor_6);
    this._TemplateRef_6_5 = new import27.TemplateRef_(this,6,this._anchor_6);
    this._NgIf_6_6 = new import23.Wrapper_NgIf(this._vc_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText((null as any),'\n    \n    ',(null as any));
    this.compView_4.create(this._StatusComponent_4_3.context);
    this._text_8 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray2(2,'retry',(null as any)),this.eventHandler(this.handleEvent_4));
    this._StatusComponent_4_3.subscribe(this,this.eventHandler(this.handleEvent_4),true);
    this._pipe_translate_0 = new import26.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._text_8
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import29.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import27.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import29.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    if (((token === import24.StatusComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._StatusComponent_4_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import30.ValueUnwrapper();
    const currVal_2_0_0:any = this.parentView.context.showDoctypes;
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:any = this.parentView.context.status;
    this._StatusComponent_4_3.check_status(currVal_4_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_4_0_1:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('ERROR: KEYWORDS')),'');
    this._StatusComponent_4_3.check_error(currVal_4_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    this._StatusComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_6_0_0:boolean = (!this.parentView.context.showDoctypes || this.parentView.context.searchFormModel);
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.ngDoCheck(this,this._anchor_6,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_6.detectChangesInNestedViews(throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_6.destroyNestedViews();
    this.compView_4.destroy();
    this._StatusComponent_4_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 4) && (ngContentIndex == 0))) {
      cb(this._text_5,ctx);
      cb(this._vc_6.nativeElement,ctx);
      this._vc_6.visitNestedViewRootNodes(cb,ctx);
      cb(this._text_7,ctx);
    }
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_FulltextSearchPanelComponent2(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 6)) { return new View_FulltextSearchPanelComponent3(this.viewUtils,this,6,this._anchor_6,this._vc_6); }
    return (null as any);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'retry')) {
      const pd_sub_0:any = ((<any>this.parentView.context.onRetry()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_FulltextSearchPanelComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_FulltextSearchPanelComponent,{});
export class View_FulltextSearchPanelComponent0 extends import1.AppView<import0.FulltextSearchPanelComponent> {
  _anchor_0:any;
  /*private*/ _vc_0:import18.ViewContainer;
  _TemplateRef_0_5:any;
  _NgIf_0_6:import23.Wrapper_NgIf;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_FulltextSearchPanelComponent0,renderType_FulltextSearchPanelComponent,import9.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._anchor_0 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._vc_0 = new import18.ViewContainer(0,(null as any),this,this._anchor_0);
    this._TemplateRef_0_5 = new import27.TemplateRef_(this,0,this._anchor_0);
    this._NgIf_0_6 = new import23.Wrapper_NgIf(this._vc_0.vcRef,this._TemplateRef_0_5);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [this._anchor_0]),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.TemplateRef) && (0 === requestNodeIndex))) { return this._TemplateRef_0_5; }
    if (((token === import29.NgIf) && (0 === requestNodeIndex))) { return this._NgIf_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:boolean = !this.context.isHidden;
    this._NgIf_0_6.check_ngIf(currVal_0_0_0,throwOnChange,false);
    this._NgIf_0_6.ngDoCheck(this,this._anchor_0,throwOnChange);
    this._vc_0.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_0.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 0)) { return new View_FulltextSearchPanelComponent1(this.viewUtils,this,0,this._anchor_0,this._vc_0); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/search-panel/components/fulltext-search-panel.component.ngfactory.ts